<template>
    <div class="container-auth">
      <router-view/>
    </div>
</template>
<script>
import FooterDefault from './components/Sections/FooterDefault'
export default {
	data(){
		return{
			colors:{}
		}
	},
	components: {
		FooterDefault,
	},
	metaInfo: {
		title: 'Huddle Brasil',
		link : [
			{ rel: 'favicon', href: 'huddle-favicon.png' }
		]
	},
	created(){
		// this.changeLocale("en-US");
		const { game } = this.$route.query
		if(game) localStorage.setItem('game-redirect', game)
	},
	methods:{
		changeLocale(locale) { i18n.locale = locale; }
	}
}
</script>

<style lang="scss">
	@import url('https://fonts.googleapis.com/css?family=Raleway:400,600,800,900');
	@import url('./assets/css/animate.scss');

	*{
		margin: 0;
		padding: 0;
		font-family: 'Raleway', Arial, sans-serif
	}

	.container-auth{
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
	}

	.header-login{
		z-index: 1000;
		height: 60px;
		width: 100%;
		background-color: #3defe3;
		display: flex;
		justify-content: center;
		align-items: center;
		-webkit-box-shadow: 1px 41px 115px -18px rgba(117,117,117,0.69);
		-moz-box-shadow: 1px 41px 115px -18px rgba(117,117,117,0.69);
		box-shadow: 1px 41px 115px -18px rgba(117,117,117,0.69);
	}

	.logo-empresa{
		max-height: 25px;
	}


</style>
